import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "drip4saisons_cart";
const MAX_QTY = 10;

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            const raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
            return Array.isArray(raw) ? raw : [];
        } catch {
            return [];
        }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    const addItem = (product, size) => {
        const key = `${product.lookup_key}:${size}`;
        setItems((cur) => {
            const found = cur.find((i) => i.key === key);
            if (found) {
                return cur.map((i) => (i.key === key ? { ...i, qty: Math.min(i.qty + 1, MAX_QTY) } : i));
            }
            return [
                ...cur,
                {
                    key,
                    lookup_key: product.lookup_key,
                    name: product.name,
                    price: product.price,
                    image: product.image,
                    size,
                    qty: 1,
                },
            ];
        });
        setOpen(true);
    };

    const removeItem = (key) => setItems((cur) => cur.filter((i) => i.key !== key));

    const setQty = (key, qty) =>
        setItems((cur) =>
            qty <= 0
                ? cur.filter((i) => i.key !== key)
                : cur.map((i) => (i.key === key ? { ...i, qty: Math.min(qty, MAX_QTY) } : i))
        );

    const clearCart = () => setItems([]);

    const value = useMemo(() => {
        const count = items.reduce((n, i) => n + i.qty, 0);
        const total = items.reduce((s, i) => s + i.price * i.qty, 0);
        return { items, count, total, open, setOpen, addItem, removeItem, setQty, clearCart };
    }, [items, open]);

    return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
    return useContext(CartContext);
}
